<template>
    <div id="app">
        <common-header></common-header>
        <router-view />
        <common-footer></common-footer>
        <back-top></back-top>
        <leave-message></leave-message>
    </div>
</template>
<script setup>
import CommonHeader from './components/CommonHeader.vue'
import CommonFooter from './components/CommonFooter.vue'
import BackTop from './components/BackTop.vue'
import LeaveMessage from './components/LeaveMessage.vue'
import store from '@/store'
try {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    if (userInfo) {
        store.commit('SET_DATA', { key: 'userInfo', data: userInfo })
    }

    const carts = JSON.parse(sessionStorage.getItem('carts'))
    if (carts) {
        store.commit('SET_DATA', { key: 'carts', data: carts })
    }
} catch (error) {
    console.log(error)
}

</script>
<style lang="scss">
@use './assets/styles/index.scss';
// 测试修改1
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
